import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

import constants from 'constants/index'

const styles = ({ selectedTab }) =>
  makeStyles(() => {
    const isPositionCustomization =
      constants.cookies.banner.POSITION_CUSTOMIZATION_CARD_ID
    const isPrivacyPortalCustomization =
      constants.cookies.banner.PRIVACY_PORTAL_CUSTOMIZATION_CARD_ID
    const isTextCustomization =
      constants.cookies.banner.TEXT_CUSTOMIZATION_CARD_ID
    const isTextCustomizationLevel2 =
      constants.cookies.banner.TEXT_CUSTOMIZATION_LEVEL_2_CARD_ID

    return {
      textCustomizationContainer: {
        display: selectedTab === isTextCustomization ? 'flex' : 'none',
        height: '100%',
        flexDirection: 'row',
      },
      textCustomizationLevel2Container: {
        display: selectedTab === isTextCustomizationLevel2 ? 'flex' : 'none',
        height: '100%',
        flexDirection: 'row',
      },
      positionCustomizationContainer: {
        display: selectedTab === isPositionCustomization ? 'flex' : 'none',
        height: '100%',
        justifyContent: 'space-between',
      },
      privacyPortalCustomizationContainer: {
        display: selectedTab === isPrivacyPortalCustomization ? 'flex' : 'none',
        height: '100%',
        flexDirection: 'row',
      },
      bannerPreviewContainer: {
        display: selectedTab === isTextCustomization ? 'block' : 'none',
        height: '100%',
      },
      positionPreviewContainer: {
        display: selectedTab === isPositionCustomization ? 'block' : 'none',
        height: '100%',
      },
      privacyPortalPreviewContainer: {
        display:
          selectedTab === isPrivacyPortalCustomization ? 'block' : 'none',
        height: '100%',
      },
    }
  })

styles.propTypes = {
  selectedTab: PropTypes.number.isRequired,
}

export default styles
